import axios from "axios";

export const auth = async (body) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND}/authenticate-judge/`,
      body
    );
    return { data: res.data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err.response?.data?.code?.[0] || "An unexpected error occurred",
    };
  }
};

export const checkAuth = async () => {
  const code = window.localStorage.getItem("judge_code");
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND}/authenticate-judge/`,
      { code }
    );
    return {
      log: res.data?.message === "Authentication successful",
      event_id: res.data?.event,
      error: null,
    };
  } catch (err) {
    return {
      data: null,
      error: err.response?.data?.code?.[0] || "An unexpected error occurred",
    };
  }
};

export const getProjects = async (id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND}/projects/?event_id=${id}`
    );

    return { data: res.data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err || "An unexpected error occurred",
    };
  }
};

export const getProjectById = async (eventId, id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND}/projects/${eventId}/${id}/`
    );

    return { data: res.data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err || "An unexpected error occurred",
    };
  }
};

export const getEventById = async (eventId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND}/events/${eventId}/`
    );

    return { data: res.data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err || "An unexpected error occurred",
    };
  }
};

export const vote = async (body) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND}/submit-vote/`,
      body
    );

    return { data: res.data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err || "An unexpected error occurred",
    };
  }
};
